// ignore-string-externalization
import { useEffect } from 'react';
import { useCurrentUser } from '../../../src/utils/CurrentUserProvider';

declare global {
  interface Window {
    _kiq: any;
  }
}

export const QualarooSurvey = () => {
  const { user } = useCurrentUser();
  const identity = user?.partnerIds?.qualaroo;
  const additionalProperties = user
    ? {
        name: user.name,
        username: user.username,
        loginEmail: user.loginEmail,
        // qualaroo doesn't display boolean values on the ui, unsure if they are queryable
        hasAccess: `${user.hasAccess}`,
      }
    : undefined;
  let timeout: ReturnType<typeof setTimeout>;
  useEffect(() => {
    // Qualaroo Intercept Survey
    /* eslint-disable */
    window._kiq = window._kiq || [];
    (() => {
      timeout = setTimeout(function () {
        /* istanbul ignore next */
        var d = document,
          f = d.getElementsByTagName('script')[0],
          s = d.createElement('script');
        /* istanbul ignore next */
        s.type = 'text/javascript';
        /* istanbul ignore next */
        s.async = true;
        /* istanbul ignore next */
        s.src = 'https://cl.qualaroo.com/ki.js/75875/hKp.js';
        /* istanbul ignore next */
        s.id = 'qualaroo-survey-script';
        /* istanbul ignore next */
        f.parentNode && f.parentNode.insertBefore(s, f);
        /* istanbul ignore next */
        s.addEventListener('load', () => {
          if (identity) {
            window._kiq.push(['identify', identity]);
          }
          if (additionalProperties) {
            window._kiq.push(['set', additionalProperties]);
          }
        });
      }, 10);
    })();
    return () => {
      clearTimeout(timeout);
      const script = document.getElementById('qualaroo-survey-script');
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [identity, additionalProperties]);
  return null;
};
